"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _constant = require("../constant");

var _Dropdown = _interopRequireDefault(require("@airasia/phoenix-components/components/Dropdown"));

var _utilities = _interopRequireDefault(require("../../utilities"));

var _Placepicker = _interopRequireDefault(require("./Placepicker.proptypes"));

var _constant2 = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var Container = _styledComponents.default.div.withConfig({
  displayName: "Placepicker__Container",
  componentId: "sc-1l1ttvz-0"
})(["display:flex;flex-direction:row;"]);

var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "Placepicker__IconWrapper",
  componentId: "sc-1l1ttvz-1"
})(["display:flex;flex-direction:column;justify-content:center;z-index:", ";margin-left:-10px;margin-right:-10px;cursor:pointer;"], function (_ref) {
  var isTablet = _ref.isTablet;
  return isTablet ? '101' : '10';
});

var IconWrapperInner = _styledComponents.default.div.withConfig({
  displayName: "Placepicker__IconWrapperInner",
  componentId: "sc-1l1ttvz-2"
})(["border:1px solid ", ";background-color:", ";height:32px;width:32px;border-radius:", ";display:flex;flex-direction:column;justify-content:center;align-items:center;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.greyMedium;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.backgroundColor.greyLighter;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius.XLarge;
});

var Placepicker = function Placepicker(props) {
  var viewPort = props.viewPort,
      theme = props.theme,
      originLabel = props.originLabel,
      destinationLabel = props.destinationLabel,
      originIcon = props.originIcon,
      destinationIcon = props.destinationIcon,
      originOnchange = props.originOnchange,
      destinationOnchange = props.destinationOnchange,
      originOnselect = props.originOnselect,
      destinationOnselect = props.destinationOnselect,
      originItems = props.originItems,
      destinationItems = props.destinationItems,
      defaultOrigin = props.defaultOrigin,
      defaultDestination = props.defaultDestination,
      locale = props.locale,
      originPlaceholder = props.originPlaceholder,
      destinationPlaceholder = props.destinationPlaceholder,
      _props$accessible = props.accessible,
      accessible = _props$accessible === void 0 ? false : _props$accessible,
      width = props.width,
      recentSearchIcon = props.recentSearchIcon,
      originRef = props.originRef,
      destinationRef = props.destinationRef,
      supportOneCharacterSearch = props.supportOneCharacterSearch,
      onSwapcallback = props.onSwapcallback,
      isOriginValid = props.isOriginValid,
      isDestinationValid = props.isDestinationValid,
      qpSyncStations = props.qpSyncStations,
      customProperties = props.customProperties,
      dropdownOnClickCallback = props.dropdownOnClickCallback,
      showIconBackground = props.showIconBackground,
      fireGtm = props.fireGtm,
      cityLevelGrouping = props.cityLevelGrouping,
      enableSuggestion = props.enableSuggestion;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _useState = (0, _react.useState)({
    origin: defaultOrigin || null,
    destination: defaultDestination || null
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      originDest = _useState2[0],
      setOriginDest = _useState2[1];

  (0, _react.useEffect)(function () {
    setOriginDest({
      origin: defaultOrigin || null,
      destination: defaultDestination || null
    });
  }, [defaultOrigin, defaultDestination]);

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      destinationFocus = _useState4[0],
      setDestinationFocus = _useState4[1];

  var onClickHandler = function onClickHandler() {
    // TODO: condition check, if any one of the value available.
    // eslint-disable-next-line no-unused-expressions
    onSwapcallback && onSwapcallback(); // TODO: change origin and destination!!
  }; // TODO: need to taken care localization!!.


  var originConfig = {
    viewPort: viewPort,
    label: originLabel,
    locale: locale,
    items: originItems || [],
    defaultIcon: originIcon,
    onChange: originOnchange,
    onSelect: function onSelect(val) {
      setDestinationFocus(true);
      originOnselect(val);
      isOriginValid(true);
    },
    defaultValue: originDest.origin,
    placeHolder: originPlaceholder,
    accessible: accessible,
    width: width,
    mWidth: '48%',
    recentSearchIcon: recentSearchIcon,
    supportOneCharacterSearch: true,
    customProperties: {
      id: 'origin',
      autoComplete: 'off'
    },
    inputRef: originRef,
    isValidField: isOriginValid,
    id: 'origin',
    qpSyncStations: qpSyncStations,
    hideMobileIcon: true,
    onClickCallback: dropdownOnClickCallback,
    showIconBackground: showIconBackground,
    showOptionsfromTop: true,
    isPlacePickerDropdown: true,
    fireGtm: fireGtm,
    enableSuggestion: enableSuggestion
  };
  var destinationConfig = {
    viewPort: viewPort,
    label: destinationLabel,
    locale: locale,
    items: destinationItems || [],
    defaultIcon: destinationIcon,
    onChange: destinationOnchange,
    onSelect: function onSelect(val) {
      setDestinationFocus(false);
      destinationOnselect(val);
      isDestinationValid(true);
    },
    onBlur: function onBlur() {
      setDestinationFocus(false);
    },
    defaultValue: originDest.destination,
    placeHolder: destinationPlaceholder,
    accessible: accessible,
    width: width,
    mWidth: '48%',
    isFocused: destinationFocus,
    recentSearchIcon: recentSearchIcon,
    supportOneCharacterSearch: true,
    customProperties: {
      id: 'destination',
      autoComplete: 'off'
    },
    inputRef: destinationRef,
    isValidField: isDestinationValid,
    id: 'destination',
    qpSyncStations: qpSyncStations,
    hideMobileIcon: true,
    onClickCallback: dropdownOnClickCallback,
    showIconBackground: showIconBackground,
    showOptionsfromTop: true,
    isPlacePickerDropdown: true,
    fireGtm: fireGtm,
    enableSuggestion: enableSuggestion
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Container, customProperties, /*#__PURE__*/_react.default.createElement(_Dropdown.default, (0, _extends2.default)({}, originConfig, {
      inputId: "home_flyingfrom",
      cityLevelGrouping: cityLevelGrouping,
      customProperties: _objectSpread(_objectSpread({}, customProperties), {}, {
        'aria-label': _constant2.INPUT_LABEL
      })
    })), /*#__PURE__*/_react.default.createElement(IconWrapper, {
      "aria-label": _constant2.SWITCH_BUTTON,
      role: "button",
      tabIndex: "0",
      isTablet: viewPort === _constant2.IS_TABLET
    }, /*#__PURE__*/_react.default.createElement(IconWrapperInner, {
      onKeyDown: function onKeyDown(e) {
        return _utilities.default.keyDownHandler(e, onClickHandler, _constant.KEY_CODE.ENTER);
      },
      onClick: onClickHandler
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: false,
      icon: "SwapHorizIcon",
      fontsize: "titleNormal",
      customProperties: {
        'aria-label': _constant2.SWITCH_BUTTON,
        role: 'button'
      }
    }))), /*#__PURE__*/_react.default.createElement(_Dropdown.default, (0, _extends2.default)({}, destinationConfig, {
      customProperties: _objectSpread(_objectSpread({}, customProperties), {}, {
        'aria-label': _constant2.INPUT_LABEL,
        id: 'home_flyingfrom'
      }),
      cityLevelGrouping: cityLevelGrouping
    }))));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Placepicker.propTypes = _Placepicker.default.PropTypes;
Placepicker.defaultProps = _Placepicker.default.DefaultProps;
var _default = Placepicker;
exports.default = _default;